import React, { JSX } from 'react';
import { IPropertyField } from '../../../../entities/common';
import Control from '../../base/Control';
import { IMirrorProperties } from './entities/IMirrorProperties';
import Styles from './assets/styles.scss';
import IconMirrorHorizontal from '@bimser/icons/32/mirror-horizontal';
import { FormItemTypes, IDictionary } from '@bimser/core';

export default class Mirror extends Control {
	targetId: string;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Mirror;
		this.targetId = '';
	}

	__loadProperties(data: IMirrorProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.targetId = data.targetId;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'targetId',
				type: 'string',
				common: true
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			targetId: this.targetId
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<div className={Styles.MirrorControlContainerStyle}>
				<h3
					title="Empty Mirror Control"
					className={Styles.MirrorTextContentStyle}
				>
					{this.name}
				</h3>
				<IconMirrorHorizontal className={Styles.MirrorControlIconStyle} />
			</div>
		);
	}
}
